
const ClockIcon = ({ ...props }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" { ...props }>
            <path d="M8 2.00098C4.69141 2.00098 2 4.69238 2 8.00098C2 11.3096 4.69141 14.001 8 14.001C11.3086 14.001 14 11.3096 14 8.00098C14 4.69238 11.3086 2.00098 8 2.00098ZM8 3.00098C10.7676 3.00098 13 5.2334 13 8.00098C13 10.7686 10.7676 13.001 8 13.001C5.23242 13.001 3 10.7686 3 8.00098C3 5.2334 5.23242 3.00098 8 3.00098ZM7.5 4.00098V8.50098H11V7.50098H8.5V4.00098H7.5Z" fill="black" />
        </svg>
    )
}

export default ClockIcon;